import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray } from '../colors';

type MuiCheckbox = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiCheckbox'];
  defaultProps?: ComponentsProps['MuiCheckbox'];
  variants?: ComponentsVariants['MuiCheckbox'];
};

export const MuiCheckbox: MuiCheckbox = {
  defaultProps: {
    color: 'primary',
  },
  styleOverrides: {
    root: {
      fontSize: 18,
    },
    colorSecondary: {
      color: tannerGray['700'],
      '&.Mui-checked': {
        color: tannerGray['700'],
      },
    },
    colorPrimary: {
      color: tannerGray['700'],
      '&.Mui-checked': {
        color: '#0066ED',
      },
    },
  },
};
